export const RESET_OAUTH_API_SELECTION_VALUE = 'RESET_OAUTH_API_SELECTION';
export type RESET_OAUTH_API_SELECTION = typeof RESET_OAUTH_API_SELECTION_VALUE;

export const SET_OAUTH_API_SELECTION_VALUE = 'SET_OAUTH_API_SELECTION';
export type SET_OAUTH_API_SELECTION = typeof SET_OAUTH_API_SELECTION_VALUE;
